<template>
  <div>
    <GlobalWebsiteStylesAndScripts />
    <LazyLoadInit />

    <ContentBuilderCustomScripts />
    <LightBoxInit />

    <CollectionPagesScriptsAndStyles v-if="state.isCollectionPagesVisible" />
    <SearchPageScriptsAndStyles v-if="state.isSearchPageVisible" />

    <TutcoImmediateAssistanceModal />
    <MailChimpSignUpFormModal />
    <ContinueModal />
    <ConfirmationModal />

    <NotificationsComponent v-if="notificationsStore.notifications.length > 0" />

    <CriticalCSSComponent />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted, reactive } from 'vue';
import GlobalPreloaderHelper from '@/helpers/global/globalPreloader.helper';
import useNotificationsStore from '@/store/notifications';
import useUserInfoStore from '@/store/userInfo';
import DropdownsHelper from '@/helpers/global/dropdowns.helper';

// Synchronous imports for always-used components (bundled in main chunk)
import GlobalWebsiteStylesAndScripts from '@/components/website/global/GlobalWebsiteStylesAndScripts.vue';
import LazyLoadInit from '@/components/global/LazyLoadInit.vue';
import TutcoImmediateAssistanceModal from '@/components/website/modals/TutcoImmediateAssistanceModal.vue';
import MailChimpSignUpFormModal from '@/components/website/modals/MailChimpSignUpFormModal.vue';
import ContentBuilderCustomScripts from '@/components/website/content-builder/ContentBuilderCustomScripts.vue';
import LightBoxInit from '@/components/website/content-builder/LightBoxInit.vue';
import NotificationsComponent from '@/components/global/notifications/NotificationsComponent.vue';
import ContinueModal from '@/components/website/modals/ContinueModal.vue';
import ConfirmationModal from '@/components/website/modals/ConfirmationModal.vue';

// Async imports for conditionally-used components (code splitting)
const CriticalCSSComponent = defineAsyncComponent(
  () => import('@/components/website/global/CriticalCSSComponent.vue')
);
const CollectionPagesScriptsAndStyles = defineAsyncComponent(
  () => import('@/components/website/collection-pages/CollectionPagesScriptsAndStyles.vue')
);
const SearchPageScriptsAndStyles = defineAsyncComponent(() => import('@/components/website/search-page/SearchPageScriptsAndStyles.vue'));

const notificationsStore = useNotificationsStore();
const userInfoStore = useUserInfoStore();

const state = reactive({
  isContentBuilderVisible: false,
  isCollectionPagesVisible: false,
  isSearchPageVisible: false,
});

onMounted(() => {
  GlobalPreloaderHelper.init();
  DropdownsHelper.init();

  if (IS_LOGGED_IN) {
    userInfoStore.fetchUserInfo();
  }

  state.isContentBuilderVisible = document.querySelector('.content-builder-area') !== null;
  state.isCollectionPagesVisible = IS_COLLECTION_PAGE_VISIBLE;
  state.isSearchPageVisible = IS_SEARCH_PAGE_VISIBLE;
});
</script>
